// export default function loadBMap(ak) {
//     return new Promise(function (resolve, reject) {
//         if (typeof BMap !== 'undefined') {
//             // eslint-disable-next-line
//             resolve(BMap);
//             return true;
//         }
//         window.onBMapCallback = function () {
//             // eslint-disable-next-line
//             resolve(BMap);
//         };
//         const script = document.createElement('script');
//         script.type = 'text/javascript';
//         script.src = 'https://api.map.baidu.com/api?v=1.0&ak=' +
//             '6N54N3ujNCfK9bKovNfqRcOnCHuoBoX7' +
//             '&s=1&callback=onBMapCallback';
//         script.onerror = reject;
//         document.head.appendChild(script);
//     });
// }

export function loadBMap () {
    const bmap = new Promise(function(resolve, reject) {
        if (typeof BMap !== 'undefined') {
            // eslint-disable-next-line
            resolve(BMap);
            return true;
        }

        window.onBMapCallback = function() {
            // eslint-disable-next-line
            resolve(BMap);
        };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src =
        'https://api.map.baidu.com/api?type=webgl&v=2.0&ak=' + '6N54N3ujNCfK9bKovNfqRcOnCHuoBoX7' + '&s=1&callback=onBMapCallback';
        script.onerror = reject;
        document.head.appendChild(script);
    });
    const bmapLib = new Promise(function(resolve, reject) {
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.src =
        'https://bj.bcebos.com/v1/mapopen/github/BMapGLLib/Lushu/src/Lushu.min.js';
        script2.onerror = reject;
        script2.onload = function() {
            resolve(window.BMapLib);
        };
        document.head.appendChild(script2);
    });
    return Promise.all([bmap, bmapLib])
        .then(function (result) {
            return result;
        }).catch(e => {
        });
}